/* Progressive UI enhancement only. Shopify owns cart, pricing and checkout. */
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-optimizer-engine]').forEach((engine) => {
      if (engine.dataset.aoInitialized || !('IntersectionObserver' in window)) return;
      engine.dataset.aoInitialized = 'true';
      const observer = new IntersectionObserver(([entry]) => {
        engine.classList.toggle('is-offscreen', !entry.isIntersecting);
      }, { threshold: 0 });
      observer.observe(engine);
      // The theme editor replaces sections without a full page navigation.
      const onUnload = (event) => {
        if (!event.target.contains(engine)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    });
    root.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.aoInitialized) return;
      form.dataset.aoInitialized = 'true';
      const select = form.querySelector('[data-variant-select]');
      const section = form.closest('[data-product-section]');
      const price = section?.querySelector('[data-product-price]');
      const status = section?.querySelector('[data-variant-status]');
      const button = form.querySelector('[data-add-button]');
      if (!select) return;
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        if (button) {
          button.disabled = !available;
          const label = button.querySelector('[data-add-label]');
          if (label) label.textContent = available ? 'Add to cart' : 'Unavailable';
        }
        if (status) {
          status.textContent = available ? 'Available' : 'Unavailable';
          status.classList.toggle('at-status--unavailable', !available);
        }
      };
      select.addEventListener('change', update);
      update();
    });
    root.querySelectorAll('[data-sort-select]').forEach((select) => {
      if (select.dataset.aoInitialized) return;
      select.dataset.aoInitialized = 'true';
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('[data-mobile-menu][open], .at-nav details[open], .at-filter[open]')];
    open.forEach((details) => {
      if (details.contains(document.activeElement)) details.querySelector('summary')?.focus();
      details.open = false;
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-mobile-menu][open], .at-nav details[open], .at-filter[open]').forEach((details) => {
      if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
    });
  });
})();
